import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class ClientSessionCounter implements JsonCustomConvert<ClientSession>{
    serialize() { }
    deserialize(data: any): ClientSession {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeObject(data, ClientSession);
    }
}

@JsonConverter
export class ClientSessionArrayCounter implements JsonCustomConvert<Array<ClientSession>>{
    serialize() { }
    deserialize(data: any): Array<ClientSession> {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeArray(data, ClientSession);
    }
}

@JsonObject("ClientSession")
export class ClientSession{
    @JsonProperty("id", String, true)
    id: string = "";
    @JsonProperty("location_id", String, true)
    location_id: string = "";
    @JsonProperty("start", Number, true)
    start: number = 0;
    @JsonProperty("stop", Number, true)
    stop: number = 0;
    @JsonProperty("download", Number, true)
    download: number = 0;
    @JsonProperty("upload", Number, true)
    upload: number = 0;
    @JsonProperty("duration", Number, true)
    duration: number = 0;
    @JsonProperty("mac_address", String, true)
    mac_address: string = "";
    @JsonProperty("ip_address", String, true)
    ip_address: string = "";
}


@JsonObject("ClientSessionListCount")
export class ClientSessionListCount {
    @JsonProperty("count", Number, true)
    count: number = 0;
    @JsonProperty("data", ClientSessionArrayCounter, true)
    data: Array<ClientSession> = new Array<ClientSession>();
}

@JsonObject("ClientSessionListData")
export class ClientSessionListData extends BaseResponse{
    @JsonProperty("data", ClientSessionListCount, true)
    data: ClientSessionListCount = new ClientSessionListCount;
}
